"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_use_1 = require("react-use");
function useStickiedValue(value, seconds) {
    const [stickied, toggle] = react_use_1.useToggle(false);
    react_1.useEffect(() => {
        toggle(true);
        const t = setTimeout(() => {
            toggle(false);
        }, seconds * 1000);
        return () => {
            clearTimeout(t);
        };
    }, [value]);
    if (stickied) {
        return value;
    }
    return undefined;
}
exports.useStickiedValue = useStickiedValue;
//# sourceMappingURL=useStickiedValue.js.map